class TemplateList extends HTMLElement {

    connectedCallback() {

        this.templateElList = this.querySelectorAll('[data-template]');

        this.templateTagElList = this.querySelectorAll('[data-template-tag]');

        this.templateFilterEl = this.querySelector('[data-template-filter]');

        this.filter = new Choices(this.templateFilterEl,
            {
                allowHTML: true,
                removeItemButton: true
            }
        );


        this.templateFilterEl.addEventListener('change', (e) => {

            // get multi select values
            let filters = this.filter.getValue(true);


            for (let i = 0; i < this.templateElList.length; i++) {
                let templateEl = this.templateElList[i];

                let display = false;

                if(filters.length){
                    if(templateEl.dataset.templateTags){
                        // basic contains check
                        for (let j = 0; j < filters.length; j++) {
                            let filter = filters[j].toLowerCase();
                            if(templateEl.dataset.templateTags.toLowerCase().includes(filter)){
                                display = true;
                                break;
                            }
                        }
                    }
                } else {
                    // empty filter show all
                    display = true;
                }

                templateEl.style.display = display ? 'block' : 'none';
            }
        });

        // click on tag add to filter
        this.templateTagElList.forEach((templateTagEl) => {
            templateTagEl.addEventListener('click', (e) => {
                e.preventDefault();
                let tag = templateTagEl.dataset.templateTag;

                // set filter
                this.filter.setChoiceByValue(tag);

                // trigger change
                this.templateFilterEl.dispatchEvent(new Event('change'));
            });
        });
    }

}


customElements.define('template-list', TemplateList);
